import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Trigger word for secret testing modal
const TRIGGER_WORD = 'testing';

export const useSecretTestingEasterEgg = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Only enable easter egg on autopilot page
    const isAutoPilotPage = location.pathname === '/autopilot';
    if (!isAutoPilotPage) return;

    // Check if any modal is open that should disable the easter egg
    const isAnyModalOpen = () => {
      // Job wizard modal
      if (document.querySelector('[data-testid="run-job-wizard-modal"]') !== null) {
        return true;
      }
      
      // Settings modals - check for their unique header text using textContent
      const h2Elements = document.querySelectorAll('h2');
      for (const h2 of h2Elements) {
        const text = h2.textContent?.trim();
        if (text === 'Profile' || text === 'Security' || text === 'Platform Credentials' || text === 'Cache Settings') {
          return true;
        }
      }
      
      return false;
    };
    let typedSequence = '';
    let sequenceTimer: NodeJS.Timeout;

    const handleKeyDown = (event: KeyboardEvent) => {
      // Don't trigger easter egg if any modal is open
      if (isAnyModalOpen()) return;
      
      // Ignore special keys
      if (event.key.length > 1) return;
      
      // Clear the sequence if too much time has passed
      clearTimeout(sequenceTimer);
      
      // Add the current key to the sequence
      typedSequence += event.key.toLowerCase();
      
      // Keep only the last characters up to trigger word length
      if (typedSequence.length > TRIGGER_WORD.length) {
        typedSequence = typedSequence.slice(-TRIGGER_WORD.length);
      }
      
      // Check if current sequence matches trigger word
      if (typedSequence === TRIGGER_WORD) {
        // Toggle the modal
        setIsModalOpen(true);
        
        // Reset sequence
        typedSequence = '';
      }
      
      // Reset sequence after 3 seconds of inactivity
      sequenceTimer = setTimeout(() => {
        typedSequence = '';
      }, 3000);
    };

    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearTimeout(sequenceTimer);
    };
  }, [location.pathname]);

  return {
    isModalOpen,
    setIsModalOpen
  };
};